import { FILTER_VARIANTS } from '../../constants';
import { FilterStateValue } from '../../types/filters';

import { isValidIndexSignature } from './isValidIndexSignature';

export const checkIsValidFilterStateValue = (
  filterVariant: FILTER_VARIANTS,
  value: FilterStateValue
) => {
  if (
    filterVariant === FILTER_VARIANTS.SELECT ||
    filterVariant === FILTER_VARIANTS.OPTION
  ) {
    return Array.isArray(value) && Boolean(value.length);
  }

  if (filterVariant === FILTER_VARIANTS.RANGE) {
    return Array.isArray(value) && value.length === 2;
  }

  if (filterVariant === FILTER_VARIANTS.INPUT) {
    return isValidIndexSignature(value);
  }

  return false;
};

export default checkIsValidFilterStateValue;
